import React, {
  Component,
  Fragment,
  useEffect,
  useMemo,
  useState,
} from "react";

import users from "../../assets/images/icon_home/user.svg";
import * as API from "../../core/service/api.js";
import {} from "../../core/feature/store";
import * as api_info from "../../core/service/api_info";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import Tabs from "../__template/BottomNavComponent";
import "react-lazy-load-image-component/src/effects/blur.css";
import { formatCurrency } from "../../config/global";
import { isDarkColor } from "../../config/DarkColorChecker";
import User from "../../core/models/user";
import Config from "../../config/Config";
import { useDispatch } from "react-redux";
import { setToken } from "../../core/feature/token/tokenSlice";
import { removeUser, setUser } from "../../core/feature/user/userSlice";
import { Dialog, Listbox, Transition } from "@headlessui/react";
import TabsMobile from "../__template/TabsMobileComponent";
import { StatsInvoice, StatsProfil } from "../common/home/Stats";
import { Calendar } from "react-calendar";
import { Swiper, SwiperSlide } from "swiper/react";
import { Keyboard, Navigation, Pagination } from "swiper";
import CalenderAcademik from "../common/home/CalenderAcademik";
import topCalendar from "../../assets/images/icon_academic/top-calendar.svg";
import TopCalendarDynamic from "../../assets/images/icon_academic/top-calendar-dynamic";

import * as api_academic from "../../core/service/api_academic";

import "./../common/home/calendar.css";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { BackButton } from "../common/BackButton";
import { toast } from "react-toastify";
import "./carosel.scss";
import CustomApp from "../../core/models/customApp";

const CalendarWeb = () => {
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const balance: Number = useAppSelector((state) => state.balance.balance);
  const user: User = useAppSelector((state) => state.user.user);
  const token: String = useAppSelector((state) => state.token.token);

  const language: String = useAppSelector((state) => state.language.language);
  const [lang, setLang] = useState<any>(language);
  const [pages, setPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [show, setShow] = useState(false);
  const [newListEvent, setNewListEvent] = useState<any>([]);
  const [listEvent, setListEvent] = useState<any>([]);
  const [listEventDay, setListEventDay] = useState<any>([]);

  const [listYear, setListYear] = useState<any>([
    moment().add(-2, "years").format("YYYY"),
    moment().add(-1, "years").format("YYYY"),
    moment().add(0, "years").format("YYYY"),
    moment().add(1, "years").format("YYYY"),
    moment().add(2, "years").format("YYYY"),
  ]);
  const [year, setYear] = useState<any>(moment().format("YYYY"));
  const [data, setData] = useState<any>([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const env = Config.BaseUrlDev;
  const { t } = useTranslation();
  const changeTahun = async (e: any) => {
    var select = e.target.value;
    var tahun = [];
    for (let index = 0; index < 5; index++) {
      if (index == 0) {
        tahun.push(moment(select).add(-2, "years").format("YYYY"));
      }
      if (index == 1) {
        tahun.push(moment(select).add(-1, "years").format("YYYY"));
      }
      if (index == 2) {
        tahun.push(moment(select).add(-0, "years").format("YYYY"));
      }
      if (index == 3) {
        tahun.push(moment(select).add(1, "years").format("YYYY"));
      }
      if (index == 4) {
        tahun.push(moment(select).add(2, "years").format("YYYY"));
      }
    }
    setListYear(tahun);
    setYear(e.target.value);
    var bulan =
      parseInt(moment().subtract(1, "month").startOf("month").format("MM")) - 1;
    var bulan1 =
      parseInt(moment().subtract(0, "month").startOf("month").format("MM")) - 1;
    var bulan2 =
      parseInt(moment().subtract(-1, "month").startOf("month").format("MM")) -
      1;
    var bulan3 =
      parseInt(moment().subtract(-2, "month").startOf("month").format("MM")) -
      1;
    var bulan4 =
      parseInt(moment().subtract(-3, "month").startOf("month").format("MM")) -
      1;
    var bulan5 =
      parseInt(moment().subtract(-4, "month").startOf("month").format("MM")) -
      1;
    var bulan6 =
      parseInt(moment().subtract(-5, "month").startOf("month").format("MM")) -
      1;
    var bulan7 =
      parseInt(moment().subtract(-6, "month").startOf("month").format("MM")) -
      1;
    var bulan8 =
      parseInt(moment().subtract(-7, "month").startOf("month").format("MM")) -
      1;
    var bulan9 =
      parseInt(moment().subtract(-8, "month").startOf("month").format("MM")) -
      1;
    var bulan10 =
      parseInt(moment().subtract(-9, "month").startOf("month").format("MM")) -
      1;
    var bulan11 =
      parseInt(moment().subtract(-10, "month").startOf("month").format("MM")) -
      1;
    var bulan12 =
      parseInt(moment().subtract(-11, "month").startOf("month").format("MM")) -
      1;

    var convTangggal = moment(e.target.value + "-01-01").format("YYYY-MM-DD");
    var tanggalAkhir = moment(e.target.value + "-12-31").format("YYYY-MM-DD");

    api_academic
      .getAgenda(convTangggal, tanggalAkhir)
      .then((res: any) => {
        var c = res.data.content;
        var groupKey = 0;
        var groups = c.reduce((r: any, o: any) => {
          // var m = o.startDate.split(('-'))[1] == '01' ? 'Januari' : o.startDate.split(('-'))[1] == '02' ? 'Februari' : o.startDate.split(('-'))[1] == '03' ? 'Maret' : o.startDate.split(('-'))[1] == '04' ? 'April' : o.startDate.split(('-'))[1] == '05' ? 'Mei' : o.startDate.split(('-'))[1] == '06' ? 'Juni' : o.startDate.split(('-'))[1] == '07' ? 'Juli' : o.startDate.split(('-'))[1] == '08' ? 'Agustus' : o.startDate.split(('-'))[1] == '09' ? 'September' : o.startDate.split(('-'))[1] == '10' ? 'Oktober' : o.startDate.split(('-'))[1] == '11' ? 'November' : 'Desember';
          var m = o.startDate.split("-")[1];
          // r[m].startDate.push(o)
          r[m] ? r[m].cek.push(o) : (r[m] = { cek: [o] });
          return r;
        }, {});
        setNewListEvent(groups);
        setListEvent(res.data.content);
      })
      .catch((e: any) => {
        // navigate("/login", { replace: true });
        console.log(e);
      });

    setData([
      {
        date: new Date(e.target.value, bulan1, 1),
      },
      {
        date: new Date(e.target.value, bulan2, 1),
      },
      {
        date: new Date(e.target.value, bulan3, 1),
      },
      {
        date: new Date(e.target.value, bulan4, 1),
      },
      {
        date: new Date(e.target.value, bulan5, 1),
      },
      {
        date: new Date(e.target.value, bulan6, 1),
      },
      {
        date: new Date(e.target.value, bulan7, 1),
      },
      {
        date: new Date(e.target.value, bulan8, 1),
      },
      {
        date: new Date(e.target.value, bulan9, 1),
      },
      {
        date: new Date(e.target.value, bulan10, 1),
      },
      {
        date: new Date(e.target.value, bulan11, 1),
      },
      {
        date: new Date(e.target.value, bulan12, 1),
      },
    ]);
  };

  function getData(params: any) {
    var dateNow = parseInt(moment().format("MM"));
    var tahun = parseInt(
      moment().subtract(1, "month").startOf("month").format("YYYY")
    );
    var tahun1 = parseInt(
      moment().subtract(0, "month").startOf("month").format("YYYY")
    );
    var tahun2 = parseInt(
      moment().subtract(-1, "month").startOf("month").format("YYYY")
    );
    var tahun3 = parseInt(
      moment().subtract(-2, "month").startOf("month").format("YYYY")
    );
    var tahun4 = parseInt(
      moment().subtract(-3, "month").startOf("month").format("YYYY")
    );
    var tahun5 = parseInt(
      moment().subtract(-4, "month").startOf("month").format("YYYY")
    );
    var tahun6 = parseInt(
      moment().subtract(-5, "month").startOf("month").format("YYYY")
    );
    var tahun7 = parseInt(
      moment().subtract(-6, "month").startOf("month").format("YYYY")
    );
    var tahun8 = parseInt(
      moment().subtract(-7, "month").startOf("month").format("YYYY")
    );
    var tahun9 = parseInt(
      moment().subtract(-8, "month").startOf("month").format("YYYY")
    );
    var tahun10 = parseInt(
      moment().subtract(-9, "month").startOf("month").format("YYYY")
    );
    var tahun11 = parseInt(
      moment().subtract(-10, "month").startOf("month").format("YYYY")
    );
    var tahun12 = parseInt(
      moment().subtract(-11, "month").startOf("month").format("YYYY")
    );

    var bulan =
      parseInt(moment().subtract(1, "month").startOf("month").format("MM")) - 1;
    var bulan1 =
      parseInt(moment().subtract(0, "month").startOf("month").format("MM")) - 1;
    var bulan2 =
      parseInt(moment().subtract(-1, "month").startOf("month").format("MM")) -
      1;
    var bulan3 =
      parseInt(moment().subtract(-2, "month").startOf("month").format("MM")) -
      1;
    var bulan4 =
      parseInt(moment().subtract(-3, "month").startOf("month").format("MM")) -
      1;
    var bulan5 =
      parseInt(moment().subtract(-4, "month").startOf("month").format("MM")) -
      1;
    var bulan6 =
      parseInt(moment().subtract(-5, "month").startOf("month").format("MM")) -
      1;
    var bulan7 =
      parseInt(moment().subtract(-6, "month").startOf("month").format("MM")) -
      1;
    var bulan8 =
      parseInt(moment().subtract(-7, "month").startOf("month").format("MM")) -
      1;
    var bulan9 =
      parseInt(moment().subtract(-8, "month").startOf("month").format("MM")) -
      1;
    var bulan10 =
      parseInt(moment().subtract(-9, "month").startOf("month").format("MM")) -
      1;
    var bulan11 =
      parseInt(moment().subtract(-10, "month").startOf("month").format("MM")) -
      1;
    var bulan12 =
      parseInt(moment().subtract(-11, "month").startOf("month").format("MM")) -
      1;

    setData([
      {
        date: new Date(tahun, bulan, 1),
      },
      {
        date: new Date(tahun1, bulan1, 1),
      },
      {
        date: new Date(tahun2, bulan2, 1),
      },
      {
        date: new Date(tahun3, bulan3, 1),
      },
      {
        date: new Date(tahun4, bulan4, 1),
      },
      {
        date: new Date(tahun5, bulan5, 1),
      },
      {
        date: new Date(tahun6, bulan6, 1),
      },
      {
        date: new Date(tahun7, bulan7, 1),
      },
      {
        date: new Date(tahun8, bulan8, 1),
      },
      {
        date: new Date(tahun9, bulan9, 1),
      },
      {
        date: new Date(tahun10, bulan10, 1),
      },
      {
        date: new Date(tahun11, bulan11, 1),
      },
      {
        date: new Date(tahun12, bulan12, 1),
      },
    ]);
  }

  function getEventInDay(tanggal: any) {
    setShow(true);
    var convTangggal = moment(tanggal).format("YYYY-MM-DD");
    var tanggalAkhir = moment(tanggal)
      .subtract(-1, "days")
      .format("YYYY-MM-DD");
    api_academic
      .getAgenda(convTangggal, tanggalAkhir)
      .then((res: any) => {
        setListEventDay(res.data.content);
      })
      .catch((e: any) => {
        console.log(e, "eror");
      });
  }

  function getEvent(tahun: any) {
    console.log(
      moment().subtract(1, "months").startOf("month").format("DD-MM-YYYY"),
      "cektajshh"
    );
    var convTangggal = moment()
      .subtract(1, "months")
      .startOf("month")
      .format("YYYY-MM-DD");
    var tanggalAkhir = moment()
      .subtract(-11, "months")
      .endOf("month")
      .format("YYYY-MM-DD");

    api_academic
      .getAgenda(convTangggal, tanggalAkhir)
      .then((res: any) => {
        var c = res.data.content;
        var groupKey = 0;
        var groups = c.reduce((r: any, o: any) => {
          // var m = o.startDate.split(('-'))[1] == '01' ? 'Januari' : o.startDate.split(('-'))[1] == '02' ? 'Februari' : o.startDate.split(('-'))[1] == '03' ? 'Maret' : o.startDate.split(('-'))[1] == '04' ? 'April' : o.startDate.split(('-'))[1] == '05' ? 'Mei' : o.startDate.split(('-'))[1] == '06' ? 'Juni' : o.startDate.split(('-'))[1] == '07' ? 'Juli' : o.startDate.split(('-'))[1] == '08' ? 'Agustus' : o.startDate.split(('-'))[1] == '09' ? 'September' : o.startDate.split(('-'))[1] == '10' ? 'Oktober' : o.startDate.split(('-'))[1] == '11' ? 'November' : 'Desember';
          var m = o.startDate.split("-")[1];
          // r[m].startDate.push(o)
          r[m] ? r[m].cek.push(o) : (r[m] = { cek: [o] });
          return r;
        }, {});
        setNewListEvent(groups);
        setListEvent(res.data.content);
      })
      .catch((e: any) => {
        toast.error(e);
        navigate("/login", { replace: true });
      });
  }

  const [value, onChange] = useState();
  useEffect(() => {
    getEvent(year);
    getData(moment(2020).format("YYYY"));
  }, []);

  useEffect(() => {
    if (user == undefined) {
      navigate("/login", { replace: true });
    } else {
    }
  }, []);
  useEffect(() => {
    if (location.pathname.split("/")[2] != undefined) {
      dispatch(setToken(location.pathname.split("/")[2]));
      API.credentialCheck().then((resCredential) => {
        dispatch(setUser(resCredential.data.user));
      });
    }
  }, [location.pathname.split("/")[2]]);
  return (
    <>
      <div className="relative h-auto bg-psp-primary pb-20 font-montserrat">
        <StatsInvoice />
        <div className="bg-white relative z-10 rounded-2xl container w-full -mt-32 shadow-xl py-3 px-4 h-auto">
          <div className="flex">
            <BackButton />
            <div className="font-montserrat font-bold text-4xl">
              {t("CALENDAR.title")}
            </div>
          </div>
          <div className="w-full relative flex flex-row h-auto pt-4">
            <span className="text-xl font-montserrat  text-slate-400">
              Filter
            </span>
            <select
              value={year}
              onChange={(event) => {
                changeTahun(event);
              }}
              className="px-3 py-1 ml-3 rounded-md text-slate-600 w-40"
            >
              <option disabled>{t("OTHER.year")} :</option>
              {listYear.map((el: any, index: any) => (
                <option key={index} value={el}>
                  {el}
                </option>
              ))}
            </select>
          </div>
          <div
            className="mt-10"
            style={{
              transition: "0.7s",
            }}
          >
            <Swiper
              onSlideChange={(e) => {}}
              onSwiper={(swiper) => {}}
              effect={"fade"}
              grabCursor={false}
              centeredSlides={true}
              pagination={false}
              centeredSlidesBounds={true}
              loop={false}
              keyboard={{
                enabled: true,
              }}
              slidesPerView={3}
              navigation={{
                prevEl: ".swiper-button-prev",
                nextEl: ".swiper-button-next",
              }}
              onScroll={(e) => {}}
              coverflowEffect={{
                rotate: 0,
                stretch: 50,
                depth: 100,
                modifier: 2.5,
                slideShadows: false,
              }}
              modules={[Navigation, Keyboard]}
              className="w-full h-auto mb-10 sm:mb-20 relative  "
            >
              {data.map((el: any, index: any) => {
                var jan = [];
                jan = newListEvent[moment(el.date).format("MM")]?.cek ?? [];
                return (
                  <SwiperSlide key={index}>
                    <div className="h-auto w-[25vw] max-w-sm  mr-5 rounded-2xl py-3 px-3">
                      <div className="flex-col h-auto shadow rounded-2xl bg-white relative">
                        <div className="w-full flex flex-row absolute -top-5"> 
                          <TopCalendarDynamic accent={customApp.app_accent_color} secondary={customApp.app_secondary_accent_color} />
                        </div>
                        <div className=" rounded-t-xl p-4 max-h-max w-full h-auto">
                          <div className="w-full rounded">
                            <div className="flex items-center flex-col justify-center mb-4 mt-7">
                              <div className="text-center font-bold text-xl text-black dark:text-white mt-6">
                                {`${moment(el.date).format("MMMM")} ${moment(
                                  el.date
                                ).format("YYYY")}`}
                              </div>
                            </div>
                            <div className="h-[270px]">
                              <Calendar
                                value={el.date}
                                nextLabel={null}
                                prevLabel={null}
                                locale={lang}
                                next2Label={null}
                                prev2Label={null}
                                className={"react-calendar"}
                                showNeighboringMonth={false}
                                goToRangeStartOnSelect={true}
                                showNavigation={false}
                                selectRange={false}
                                onClickDay={(date) => {
                                  getEventInDay(date);
                                }}
                                tileContent={({
                                  activeStartDate,
                                  date,
                                  view,
                                }) => {
                                  var eventtotal: any[] = [];
                                  {
                                    listEvent.forEach(
                                      (element: any, index: any) => {
                                        if (
                                          moment(element.startDate).format(
                                            "DD-MM-YYYY"
                                          ) <=
                                            moment(date).format("DD-MM-YYYY") &&
                                          moment(element.endDate).format(
                                            "DD-MM-YYYY"
                                          ) >=
                                            moment(date).format("DD-MM-YYYY") &&
                                          moment(element.startDate).format(
                                            "MM"
                                          ) === moment(date).format("MM")
                                        ) {
                                          eventtotal.push(element);
                                        }
                                      }
                                    );
                                  }
                                  return (
                                    <div className="flex flex-row justify-center ">
                                      {eventtotal.map((e: any, i: any) => {
                                        return (
                                          <>
                                            <div
                                              style={{
                                                backgroundColor: e.color,
                                                borderRadius: "50%",
                                                width: 5,
                                                height: 5,
                                              }}
                                            ></div>
                                          </>
                                        );
                                      })}
                                    </div>
                                  );
                                }}
                              />
                              <style>
                                {`
                                  .react-calendar__tile--now:enabled:hover {
                                    background-color: ${customApp.app_secondary_accent_color};
                                    color: ${isDarkColor(customApp.app_secondary_accent_color) ? 'white' : 'black'};
                                  }
                                  .react-calendar__tile--now {
                                    border-radius: 10px;
                                    color: ${isDarkColor(customApp.app_accent_color) ? 'white' : 'black'};
                                    background-color: ${customApp.app_accent_color};
                                  }
                                `}
                              </style>
                            </div>
                            <div className="mt-2">
                              <div className="font-bold">
                                {t("CALENDAR.description")}
                              </div>
                              <div className="overflow-y-auto overflow-x-hidden h-[17vh]">
                                {jan?.map((ss: any, kk: any) => (
                                  <div
                                    className="flex flex-row relative w-full m-1 items-center"
                                    key={kk}
                                  >
                                    <div
                                      style={{
                                        backgroundColor: ss.color,
                                        borderRadius: "100%",
                                        width: 10,
                                        height: 10,
                                      }}
                                    ></div>
                                    <div className="relative flex flex-col h-full top-2 ml-1  justify-center items-center">
                                      <p className="font-montserrat text-sm">
                                        {ss.description}
                                      </p>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div></div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
            <div className="flex w-full justify-center mb-2">
              <button className={`swiper-button-prev 
              disabled:bg-gray-200 
              disabled:text-gray-600
              border mr-2 hover:shadow-lg disabled:hover:shadow-none
              rounded-md w-36 hover:opacity-80 py-2 ${isDarkColor(customApp.app_accent_color)?'text-white':'text-black'}`}
              style={{ backgroundColor: customApp.app_accent_color}}>
                {t("OTHER.previous")}
              </button>
              <button className={`swiper-button-next 
              disabled:bg-gray-200 
              disabled:text-slate-400 
              border mr-2 hover:shadow-lg disabled:hover:shadow-none
              rounded-md w-36 hover:opacity-80 py-2 ${isDarkColor(customApp.app_accent_color)?'text-white':'text-black'}`}
              style={{ backgroundColor: customApp.app_accent_color}}>
                {t("OTHER.next")}
              </button>
            </div>
          </div>
        </div>
        <Transition appear show={show} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-20"
            onClose={() => setShow(false)}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto font-montserrat">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900"
                    >
                      {t("CALENDAR.description")}
                    </Dialog.Title>
                    <div className="mt-2">
                      {listEventDay.length == 0 ? (
                        <div className="relative flex flex-col h-full top-2 ml-1  justify-center items-center">
                          <p className="font-montserrat text-sm">
                            {"Tidak Ada Data"}
                          </p>
                        </div>
                      ) : null}
                      {listEventDay.map((item: any, index: any) => {
                        return (
                          <div
                            className="flex flex-row relative w-full m-1 items-center"
                            key={index}
                          >
                            <div
                              style={{
                                backgroundColor: item.color,
                                borderRadius: "100%",
                                width: 15,
                                height: 15,
                              }}
                            ></div>
                            <div className="relative flex flex-col h-full top-2 ml-1  justify-center items-center">
                              <p className="font-montserrat text-sm">
                                {item.description}
                              </p>
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    <div className="mt-4 flex gap-2">
                      <button
                        type="button"
                        className="inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                        onClick={() => setShow(false)}
                      >
                        {t("CALENDAR.back")}
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
      </div>
    </>
  );
};

export default CalendarWeb;
